module.exports = __webpack_public_path__ + "img/second-avater-2@2x.4f2fb4f.png";